import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CountdownTimer } from './CountdownTimer';
import { motion } from 'framer-motion';
export function UrgencyPrice() {
  return <SectionWrapper className="text-center max-w-3xl mx-auto" data-id="element-299">
      <div className="bg-white p-8 md:p-12 rounded-3xl shadow-lg border border-red-100 relative overflow-hidden" data-id="element-300">
        <div className="absolute top-0 left-0 w-full h-2 bg-red-500" data-id="element-301"></div>

        <h2 className="text-2xl md:text-3xl font-black text-text-main mb-8 uppercase tracking-wide" data-id="element-302">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>

        <div className="mb-8" data-id="element-303">
          <CountdownTimer data-id="element-304" />
        </div>

        <p className="text-lg md:text-xl font-medium text-text-main/80 mb-10" data-id="element-305">
          Después sube a <span className="font-bold line-through" data-id="element-306">$27 USD</span>{' '}
          y no vuelve a bajar.
        </p>

        <div className="bg-card-bg p-6 rounded-2xl border border-dusty-rose/20" data-id="element-307">
          <div className="flex justify-between items-end mb-2" data-id="element-308">
            <span className="font-bold text-burgundy flex items-center gap-2" data-id="element-309">
              <span className="relative flex h-3 w-3" data-id="element-310">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-311"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500" data-id="element-312"></span>
              </span>
              Cupos al precio de lanzamiento
            </span>
            <span className="text-sm font-bold text-red-600" data-id="element-313">Quedan pocos</span>
          </div>

          <div className="w-full bg-gray-200 rounded-full h-4 mb-2 overflow-hidden" data-id="element-314">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '72%'
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="bg-burgundy h-4 rounded-full" data-id="element-315"></motion.div>
          </div>
          <p className="text-right text-xs font-bold text-text-main/60" data-id="element-316">
            72% de los cupos tomados
          </p>
        </div>
      </div>
    </SectionWrapper>;
}